export class FabShopStockProductType {
    id!: string
    name!: string
    sortOrder = 0
    archived = false
}
